// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import type { SelectedInterest } from 'app/common/react/components/growth/activation/NuxContainer/NuxContainer';
import { Box, Button, Icon, Image, Mask, Text } from 'gestalt';

type Props = {|
  selectedInterest: SelectedInterest,
|};

function NuxEducationLoaderPin({ selectedInterest }: Props) {
  const defaultSelectedInterest = {
    label: i18n._('Food and Drink', 'Title for topic'),
    images: {
      '400x': {
        height: 561,
        url: 'https://i.pinimg.com/400x/10/31/0a/10310a3d860e8f7f2a5753612a870f5a.jpg',
        width: 400,
      },
    },
  };
  const attributes = {};
  const { label, images } = selectedInterest || defaultSelectedInterest;
  const {
    '400x': { url, height, width },
  } = images;
  attributes.domain = label
    .trim()
    .toLowerCase()
    .replace(/\s/g, '')
    .concat('.com');
  attributes.imageHeight = height;
  attributes.imageWidth = width;
  attributes.imageUrl = url;

  const { domain, imageUrl, imageHeight, imageWidth } = attributes;

  return (
    <div className="NuxEducationLoaderPin" data-test-id="nux-loader-pin">
      <Box position="relative">
        <div className="NuxEducationLoaderPin__pinImage">
          <Mask shape="rounded" height={310} width={210}>
            <Image
              alt={i18n._('Pin image', 'Pin image for nux loading step')}
              color="darkGray"
              fit="cover"
              naturalHeight={imageHeight}
              naturalWidth={imageWidth}
              src={imageUrl}
            />
          </Mask>
          <Box position="absolute" top right marginTop={1} marginRight={1}>
            <div className="NuxEducationLoaderPin__pinSaveButton">
              <Button
                accessibilityLabel={i18n._('Save button')}
                color="red"
                text={i18n._('Save', 'save button for nux loading step')}
                size="md"
              />
            </div>
          </Box>
          <Box position="absolute" bottom left margin={2} maxWidth="90%">
            <div className="NuxEducationLoaderPin__pinLinkButton">
              <Box
                padding={2}
                color="lightGray"
                display="flex"
                justifyContent="between"
                alignItems="center"
                dangerouslySetInlineStyle={{ __style: { borderRadius: 4 } }}
              >
                <Box>
                  <Icon
                    icon="arrow-up-right"
                    accessibilityLabel={i18n._('link', 'Pin website url link for nux loading step')}
                    size={14}
                    color="darkGray"
                  />
                </Box>
                <Box marginLeft={2} height={18} flex="grow" overflow="hidden">
                  <Text bold size="sm" truncate>
                    {domain}
                  </Text>
                </Box>
              </Box>
            </div>
          </Box>
        </div>
      </Box>
    </div>
  );
}

// $FlowIssue Currently installed version of Flow doesn't understand React.memo
export default React.memo(NuxEducationLoaderPin);
